import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const resetForgotPasswordCacheKey = 'resetForgotPassword';
export const resetForgotPasswordMutation = graphql(/* GraphQL */ `
    mutation ResetForgotPassword(
        $token: String!
        $password: String!
        $passwordConfirm: String!
        $recaptchaToken: String
    ) {
        resetForgotPassword(
            token: $token
            password: $password
            passwordConfirm: $passwordConfirm
            recaptchaToken: $recaptchaToken
        ) {
            success
        }
    }
`);
